
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import IntroduceCard from "../components/introduce-card.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import HinaRadioGroup from "@/views/ai-builder-component/baseComponent/hina-radio-group.vue";
import HinaDatePicker from "@/views/ai-builder-component/baseComponent/hina-date-picker.vue";
import Pop from "@/views/ai-builder-component/components/blue-pop.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import HinaCheckboxGroup from "@/views/ai-builder-component/baseComponent/hina-checkbox-group.vue";
import HinaSwitch from "@/views/ai-builder-component/baseComponent/hina-switch.vue";
import dayjs from "dayjs";

@Component({
  components: {
    HinaSwitch,
    HinaCheckboxGroup,
    InputNumberV3,
    Pop,
    HinaRadioGroup,
    HinaDatePicker,
    IntroduceCard
  }
})
export default class BaseInfoCom extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据
  @Prop({ default: "" }) builder!: string; // 创建面试来源

  get timeLimitConfig() {
    return this.formItemData.timeLimitConfig;
  }

  // 限制面试有效期
  get timeArr() {
    return [this.timeLimitConfig.beginTime, this.timeLimitConfig.endTime];
  }
  set timeArr(v: string[]) {
    this.timeLimitConfig.beginTime = v?.[0] || "";
    this.timeLimitConfig.endTime = v?.[1] || "";
  }

  handleChangeTimeArr(v: string[]) {
    this.timeLimitConfig.beginTime = v?.[0] || "";
    this.timeLimitConfig.endTime = v?.[1] || "";
  }

  get noEndingOptions() {
    return [
      { name: "长期有效", value: 1 },
      {
        name: "指定时间",
        value: 2,
        disabled: this.timeLimitConfig.timeLimitGiveUp !== 0
      }
    ];
  }

  get examTakeTime() {
    let second = 0;
    if (this.formItemData.questions.isRandomQuestion === 1) {
      this.formItemData.questions.randomConfigList.forEach(question => {
        const n = question.questionNumber;
        second += n * 30;
        if ([6, 8].includes(question.questionType)) {
          question.questionIdList.forEach(qid => {
            const qParams = this.formItemData.questions.questionConfigList.find(
              child => child.questionId === qid
            );
            const prepareTime = qParams?.preparationTime ?? 0;
            second += prepareTime ? prepareTime : 10;
            const answerTime = qParams?.answerTime ?? 0;
            second += answerTime ? answerTime : 3 * 60;
          });
        }
      });
    } else {
      this.formItemData.questions.questionConfigList.forEach(question => {
        second += 30;
        if ([6, 8].includes(question.questionType)) {
          second += 60;
          second +=
            question.preparationTime > 0 ? question.preparationTime : 10;
          second += question.answerTime > 0 ? question.answerTime : 3 * 60;
        }
      });
    }
    second += this.formItemData.colorDetection.use === 1 ? 60 : 0;
    second +=
      this.formItemData.tacPsycGauge.use === 1
        ? this.formItemData.tacPsycGauge.configDataList.length * 5 * 60
        : 0;
    second += this.formItemData.handDetection.use === 1 ? 60 : 0;
    second += this.formItemData.bgCheck.use === 1 ? 10 : 0;
    second += this.formItemData.livenessRecognition.use === 1 ? 60 : 0;
    const minutes = Math.ceil(second / 60);
    return minutes;
  }

  @Watch("examTakeTime", { immediate: true })
  changeExamTakeTime(val: number) {
    this.$emit("takeTime", val * 60);
  }

  handleChangeNoEnding(v: number) {
    if (v === 1) {
      this.timeLimitConfig.beginTime = dayjs(new Date()).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    } else {
      this.timeArr = [];
    }
  }

  // 到达时间自动交卷范围
  @Watch("timeLimitConfig.timeLimitGiveUp")
  handleChangeGiveUp(value: number, oldValue: number) {
    if (!value && oldValue) {
      this.timeLimitConfig.giveUpNotSignIn = 2;
      this.timeLimitConfig.giveUpSignIn = 2;
    } else if (value && !oldValue) {
      this.timeLimitConfig.giveUpNotSignIn = 1;
      this.timeLimitConfig.giveUpSignIn = 1;
    }
  }

  giveUpSignInChange(value: number, key: string) {
    if (value !== 1) {
      this.timeLimitConfig[key] = 1;
    }
  }

  get timeLimitGiveUpOptions() {
    return [
      { name: "不限制", value: 0 },
      {
        name: "12小时",
        value: 43200,
        disabled: this.timeLimitConfig.noEnding === 2
      },
      {
        name: "24小时",
        value: 86400,
        disabled: this.timeLimitConfig.noEnding === 2
      },
      {
        name: "48小时",
        value: 86400 * 2,
        disabled: this.timeLimitConfig.noEnding === 2
      },
      {
        name: "72小时",
        value: 259200,
        disabled: this.timeLimitConfig.noEnding === 2
      }
    ];
  }

  // 面试时间限制
  get examHour() {
    return Math.floor(
      this.formItemData.timeLimitConfig.timeLimitExam / 60 / 60
    );
  }
  set examHour(v: number) {
    const time = (v * 60 + this.examMin) * 60;
    this.formItemData.timeLimitConfig.timeLimitExam = time;
    this.formItemData.timeLimitConfig.timeLimitExamType =
      time === 24 * 60 * 60 ? 1 : 2;
  }

  get examMin() {
    return Math.floor(
      (this.formItemData.timeLimitConfig.timeLimitExam / 60) % 60
    );
  }
  set examMin(v: number) {
    const time = (this.examHour * 60 + v) * 60;
    this.formItemData.timeLimitConfig.timeLimitExam = time;
    this.formItemData.timeLimitConfig.timeLimitExamType =
      time === 24 * 60 * 60 ? 1 : 2;
  }

  // 重复作答次数
  get repeatAnswerConfig() {
    return this.formItemData.repeatAnswerConfig;
  }

  get repeatTime() {
    return this.repeatAnswerConfig.repeatAnswerLimit > 0 ? 1 : 2;
  }
  // set repeatTime(val) {
  //   this.repeatAnswerConfig.repeatAnswerLimit = val === 2 ? 0 : 1;
  // }

  formItemCheck() {
    return new Promise(resolve => {
      if (!this.examMin && !this.examHour) {
        resolve("baseInfo");
      } else {
        resolve("");
      }
    });
  }

  handleChangeRepeatTime(v: number) {
    if (v === 2) {
      this.repeatAnswerConfig.repeatAnswerLimit = 0;
    } else {
      this.repeatAnswerConfig.repeatAnswerLimit = 1;
    }
  }

  get useRepeatLimitTime() {
    return this.repeatAnswerConfig.repeatAnswerDayLimit > 0;
  }
  set useRepeatLimitTime(v: boolean) {
    this.repeatAnswerConfig.repeatAnswerDayLimit = v ? 1 : 0;
  }
}
